module.exports = __webpack_public_path__ + "img/26.19731408.jpg";